 export const uploadToGCS = async (file, generateUploadUrl) => {

  const contentType = file.type || 'application/octet-stream'; // Ensure a valid content type
  // Create a unique filename; you might include a timestamp or a folder path.
  const filename = `uploads/${Date.now()}-${file.name}`;

  // Use the GraphQL mutation to generate a signed URL
  const { data, errors, loading } = await generateUploadUrl({
    variables: { filename, contentType },
  });

  if (loading) {
    return "Loading...";
  }

  if (errors) {
    throw new Error(errors[0].message);
  }

  const signedUrl = data.generateUploadUrl;

   // Upload the file to Google Cloud Storage using the signed URL
   // Upload the file to Google Cloud Storage using the signed URL
   try {
     const uploadResponse = await fetch(signedUrl, {
       method: 'PUT',
       headers: { 'Content-Type': contentType },
       body: file,
     });

  if (!uploadResponse.ok) {
    // Attempt to read and parse the error response for more details
    const errorText = await uploadResponse.text();
    let errorDetails;
    try {
      errorDetails = JSON.parse(errorText);
    } catch (parseError) {
      errorDetails = errorText;
    }

    console.error("Upload failed with response details:", {
      status: uploadResponse.status,
      statusText: uploadResponse.statusText,
      error: errorDetails,
      signedUrl,      // Ensure these are safe to log in your environment
      contentType,
    });

    throw new Error(`Upload failed with status ${uploadResponse.status}: ${uploadResponse.statusText}`);
  }
} catch (err) {
  // Log detailed error information for debugging
  console.error("Fetch error during file upload:", {
    errorName: err.name,
    errorMessage: err.message,
    errorStack: err.stack,
    signedUrl,               // Log with caution if it contains sensitive data
    contentType,             // Additional context about the file type
    fileSize: file ? file.size : 'unknown',  // File size in bytes, if available
    timestamp: new Date().toISOString(),     // When the error occurred
  });

  // Extra hint for TypeError which is common for network/CORS issues
  if (err instanceof TypeError) {
    console.error("A TypeError occurred. This may be due to network connectivity issues, CORS restrictions, or an invalid/expired signed URL.");
  }

  // Propagate the error after logging
  throw new Error(`File upload encountered an error: ${err.message}. Check the browser console and network tab for more details.`);
}



  // Construct the public URL for the uploaded file
  const publicUrl = `https://storage.googleapis.com/${process.env.REACT_APP_GCLOUD_BUCKET_NAME}/${filename}`;

  return publicUrl;
}; 

